/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import InputWithLabel from '../../input-with-header';
import Modal from '../../modal';
import { StationReviewType } from '../../../utils/prop-types/review-types';
import ReviewCard from '../review-card';
import StationWithAddress from '../../station-with-address';
import EnsureDelivery from '../../ensure-delivery';
import Notification from '../../notification';

import styles from './styles.css';
import EmailChipList from '../../email-chip-list';

const { api, logError } = require('../../../../lib/bputils').default;
const { canReplyReview } = require('../../../../lib/permissions').default;

const canReply = canReplyReview();

export default function EmailReviewButton({ className, review }) {
  const [emails, setEmails] = React.useState([]);
  const [comments, setComments] = React.useState('');
  const [emailsError, setEmailsError] = React.useState('');

  const handleOnShareReview = async () => {
    if (!emails.length) {
      setEmailsError('Please enter at least one recipient');
      return false;
    }

    const { id: reviewId } = review;

    try {
      await api.post({
        requestId: 'sendEmailReviewReqeust',
        path: '/export/reviews/email',
        data: {
          review_id: reviewId,
          recipients: emails,
          message: comments,
          useNewEmailDesign: true,
        },
      });
      Notification.success('Email requested!');
    } catch (err) {
      logError(err);
      Notification.error('There was an error requesting review email.');
    }
    return true;
  };

  const handleOnModalClose = () => {
    setEmails([]);
    setComments('');
  };

  const handleEmailInputChange = (e) => {
    setEmails(e);
    if (emailsError.length) {
      setEmailsError('');
    }
  };

  const handleOnCommentsInputChange = ({ currentTarget: { value } }) => {
    setComments(value);
  };

  return (
    <>
      { canReply ? (
        <Modal
          className={className}
          title="Share Review"
          saveButtonText="SHARE REVIEW"
          onSave={handleOnShareReview}
          onClose={handleOnModalClose}
          button={<FontAwesomeIcon icon={faEnvelope} className={styles.emailButton} />}
        >
          <StationWithAddress station={review.station} />
          <ReviewCard review={review} insideModal />
          <EmailChipList
            recipients={emails}
            onListChange={handleEmailInputChange}
            error={emailsError}
            onErrorChange={setEmailsError}
          />
          <InputWithLabel
            label="Add a Comments"
            onChange={handleOnCommentsInputChange}
            editable
            textArea
            value={comments}
          />
          <EnsureDelivery />
        </Modal>
      ) : null}
    </>
  );
}

EmailReviewButton.propTypes = {
  className: PropTypes.string,
  review: StationReviewType.isRequired,
};

EmailReviewButton.defaultProps = {
  className: '',
};
